import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

const GalleryLightbox = ({ open, currentImage, slides, onClose }) => {
  const CopyrightFooter = () => (
    <>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          textAlign: "center",
          padding: "10px",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          width: "100%",
          fontSize: "16px",
        }}
      >
        &copy; Nant Power. This image is for authorised editorial use only and
        may not be reproduced without permission.
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0)",
          zIndex: 1,
        }}
      />
    </>
  );

  return (
    <Lightbox
      plugins={[Captions]}
      slides={slides}
      open={open}
      index={currentImage}
      close={onClose}
      styles={{
        container: {
          background: "rgba(0, 0, 0, 0.8)",
        },
      }}
      onBackdropClick={onClose}
      render={{
        slideFooter: CopyrightFooter,
      }}
    />
  );
};

export default GalleryLightbox;
